import { useState } from "react"

export const useWorkflowBindingFormHandling = () => {

    const [formData,setFormData] = useState({
        workflowStepId: "",
        bindingTypeId: "",
        bindingId: "",
        bindingConfig: "",
        environmentId: "",
        isActive: true,

        workflowStepIdStatus: "unchecked",
        bindingTypeIdStatus: "unchecked",
        bindingIdStatus: "unchecked",
        bindingConfigStatus: "unchecked",
        environmentIdStatus: "unchecked"
    });
    
    const handleChange = (event,selectEvent) => {
        let formState ={...formData};

        if(event?.target === undefined && selectEvent){
            switch(selectEvent.name){
                
                case "workflowStepId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,70})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                case "bindingTypeId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    formState.bindingId = "";
                    formState.bindingIdStatus = "unchecked";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }   

                case "bindingId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }   

                case "environmentId": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,170})$");

                    if (alphaNLenghthRegex.test(event?.trim?.())) {
                    formState[selectEvent.name + "Status"] = "success";
                    } else {
                    formState[selectEvent.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }
                    
                default: {
                    
                    formState[selectEvent.name] = event;
                    formState[selectEvent.name + "Status"] = event ? "success" : "unchecked";
                    break;
                }
            }
            
            formState[selectEvent.name] = event;
        }
        else if(event && event.target){
            switch(event.target.name){
                case "bindingConfig": {
                    const alphaNLenghthRegex = new RegExp("^([\\s\\S]{1,100})$");

                    if (alphaNLenghthRegex.test(event.target.value.trim()?.trim?.())) {
                    formState[event.target.name + "Status"] = "success";
                    } else {
                    formState[event.target.name + "Status"] =
                        event === "" ? "unchecked" : "error";
                    }

                    break;
                }

                default: {

                    formState[event.target.name] = event.target.value;
                    formState[event.target.name + "Status"] =
                    event.target.value === "" ? "unchecked" : "success";
                    break;
                }
            }
            formState[event.target.name] = event.target.value;
        }
        setFormData(formState);
    
    }

    const checkAllFields = () => {
        let allowSubmit = false;

        if (
        formData.workflowStepIdStatus === "success" &&
        formData.bindingTypeIdStatus === "success" &&
        formData.bindingIdStatus === "success" &&
        formData.environmentIdStatus === "success" &&
        formData.bindingConfigStatus === "success" 
        ) {
        allowSubmit = true;
        } else {
        allowSubmit = false;
        }

        return allowSubmit;
    };

    return{
        formData,
        setFormData,
        handleChange,
        checkAllFields
    }
}